import { z } from 'zod/v4-mini';
import { ZodTiming } from './Timing.js';
import { matchingZodObject } from '../utilities/matchingZodObject.js';
import { ZodTaskMessage } from './TaskMessage.js';
export const ZodTaskDescription = matchingZodObject({
    id: z.string(),
    name: z.string(),
    status: z.literal(['pending', 'complete']),
    inputPath: z.string(),
    outputPath: z.optional(z.string()),
    errors: z.optional(z.array(ZodTaskMessage)),
    warnings: z.optional(z.array(ZodTaskMessage)),
    startTime: z.number(),
    duration: z.optional(z.number()),
    lastUpdated: z.optional(z.number()),
    timings: z.optional(z.array(ZodTiming)),
});
//# sourceMappingURL=TaskDescription.js.map